// WithPinMessageButton.js
import { connect } from 'react-redux';

import WithPinMessageButton from '../component/WithPinMessageButton.jsx';

import submitFeedsPin from '../action/submitFeedsPin.js';
import { getReturnType } from '../action/fetchFeeds.js';
import toggleModal from '../action/toggleModal.js';

import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import getListData from '../selector/getListData.js';
import getMessageData from '../selector/getMessageData.js';
import getFeedName from '../selector/getFeedName.js';
import { getSelectedQueryOptionObject } from '../selector/getFeedQueryObject.js';

import {
  PROFILE_FEED_REMOTE_CONFIG_KEY_MAP,
  PROFILE_PIN_REMOTE_CONFIG_KEY_MAP,
} from '../resource/profileConstants.js';

const mapStateToProps = (state, { messageId, profileListType }) => {
  const senderId = getMessageData(state, messageId, 'senderId');
  const { intersectedFeedName: pinFeedAlias } = senderId
    ? getSelectedQueryOptionObject(
        state,
        getFeedName(
          state,
          PROFILE_FEED_REMOTE_CONFIG_KEY_MAP[profileListType],
          '{USER_ID}',
          senderId
        )
      )
    : {};
  return {
    messageId,
    pinFeedAlias,
    pinnedItemIds: getListData(
      state,
      [
        'home',
        getReturnType({ feedName: pinFeedAlias }),
        pinFeedAlias,
        'pinned',
      ],
      'itemIds'
    ),
    pinMax: getRemoteConfigData(
      state,
      PROFILE_PIN_REMOTE_CONFIG_KEY_MAP[profileListType]
    ),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    submitFeedsPin: data => dispatch(submitFeedsPin(data)),
    toggleModal: data => dispatch(toggleModal(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WithPinMessageButton);
